import { render, staticRenderFns } from "./PreviewDocx.vue?vue&type=template&id=5da29718&scoped=true"
import script from "./PreviewDocx.vue?vue&type=script&lang=js"
export * from "./PreviewDocx.vue?vue&type=script&lang=js"
import style0 from "./PreviewDocx.vue?vue&type=style&index=0&id=5da29718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da29718",
  null
  
)

export default component.exports